import { Omit } from '@40seas/entities/common';
import { InsuranceCoverRequest } from './insurance.cover-requests.entity';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateInsuranceCoverRequestDto extends Omit(InsuranceCoverRequest, [...BaseEntityFieldsArray]) {}
